import React from "react";

export const Features = (props) => {
  return (
    <section id="features" className="text-center">
      <div className="container">
        <div className="col-md-10 col-md-offset-1 section-title">
          <span className="section-kicker">THE WAY WE WORK</span>
          <h2>Built on trust. <span>Focused on outcomes.</span></h2>
          <p>Good technology starts with a team that listens, communicates, and follows through.</p>
        </div>
        <div className="row feature-grid">
          {props.data
            ? props.data.map((d, i) => (
                <div key={`${d.title}-${i}`} className="col-xs-12 col-md-3">
                  <article className="feature-card">
                    <span className="feature-icon"><i className={d.icon} aria-hidden="true"></i></span>
                    <h3>{d.title}</h3>
                    <p>{d.text}</p>
                  </article>
                </div>
              ))
            : "Loading..."}
        </div>
      </div>
    </section>
  );
};
